import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import {  BaseRequest } from '../../_models/formularios/bines-emisor-nacional';
 
import { ROUTE_ANIMATION, ROUTE_ANIMATION_HOST } from '../../app.routing.animation';
import { ZeroService } from 'src/app/_services/zero/zero.service';
import {  MzToastService, MzCollapsibleComponent, MzModalComponent, MzModalService } from 'ngx-materialize';
import { FormularioDinamicoModel } from 'src/app/_models/form-dinamico.model';
import { REST_SERVICES } from 'src/app/_services/settings';
import { CatalogoModel, InstitucionCashModel } from 'src/app/_models/bin-catalogos.model';
import { Globals } from 'src/app/_services/zero/globals';
import { PlantillaModel, BeanRequest, CamposConfigModel } from 'src/app/_models/plantilla.model';
import { BinGenericRequest } from 'src/app/_models/bin-generic.model'; 
import { AuthenticationService } from 'src/app/_services/authentification.service';
import { CampoExtraRequest } from 'src/app/_models/bin-campo-extra.model';
import { ToastrService} from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { BinManagerParams } from 'src/app/_models/bin-catalogos.model'
import { EMPTY } from 'rxjs';
import { CamposService } from 'src/app/_services/campos.service';
import { CamposModificados } from 'src/app/_models/datos-bin-modificado.model';
@Component( {
  selector: 'app-bines-abc',
  templateUrl: './bines-abc.component.html',
  styleUrls:[ './bines-abc.component.css'], 
  host: ROUTE_ANIMATION_HOST, 
  animations: [ROUTE_ANIMATION],
})
export class BinesAbcComponent implements OnInit {
  
  @ViewChild('acordeon') acordeon: MzCollapsibleComponent;
  @ViewChild('bottomSheetModal') modal: MzModalComponent;
  @ViewChild('tipoBin') tipoBin:ElementRef;
  @ViewChild('bin') bin:ElementRef;
  @ViewChild('valCashCredito') valCashCredito:ElementRef;
  
  /*
   * Valor de selector 
   */
  public selectTipoBin: number;
  public selectInstitu: number;

  public mostrarBoton : boolean = true;
  public mostrarInstitucion : boolean = true;
  public options: Pickadate.DateOptions;
  public formularioConError:boolean = false;
  public numeroSecciones:number;
  public seccionActual:number;
  public valNatBin:number = 0;

  public emisorNacionalRequest : BaseRequest = new BaseRequest();
  public datosBean:BeanRequest ;
  public camposformulario: Array<FormularioDinamicoModel>;
  public tipoBines:Array<CatalogoModel>;
  
  public instituciones:Array<CatalogoModel>;
  public binRequest:BinGenericRequest;
  public isCheck: boolean;
  public isBinManager: boolean = false;
  public instSelected: boolean = false;
  private datePipe: DatePipe;
  public isOnChange:boolean = false;
  public camposConfigModel: Array<CamposConfigModel>;
  public binesParams: BinManagerParams;
  public deshabilitar: boolean;
  public regresar: string;
  public plantillaConsulta: boolean;
  public idBin:string;
  public grupo:string;
  public camposPlantilla: Array<PlantillaModel>;
  public idInstitucionAnterior: number = -1;
  datosInstitucionCash: InstitucionCashModel = new InstitucionCashModel();
  public isInter:Boolean;
  
  public datoBinModificado: CamposModificados;
  public campos = Array<String>();
  public classModificado: string = 'modificado'
  public prefijosBin: string;
  public origenInfo: string;
  public idGrupo: number;
  public regexAdquirente: string = '[^0-9]';
  public regexEmisor: string = '[^0-9,-]';

  constructor(private zeroService: ZeroService, private _router: ActivatedRoute, public router: Router,
              private toastService: MzToastService, private global:Globals, private authenticationService: AuthenticationService,
              private toastr: ToastrService, private modalService :MzModalService, private obsCampos: CamposService) {

    this.plantillaConsulta = true;
    this.datosBean = new BeanRequest();
    this.datoBinModificado = new CamposModificados();

    this.isCheck =  this._router.snapshot.paramMap.get('check') 
             ? JSON.parse(this._router.snapshot.paramMap.get('check')) : false ;
    this.origenInfo = this._router.snapshot.queryParamMap.get('origenInfo');
    this.idGrupo = this._router.snapshot.queryParamMap.get('idGrupo')?JSON.parse(this._router.snapshot.queryParamMap.get('idGrupo')):null;
    this.obsCampos.obs.subscribe(data => {

        if (data && (data.url != undefined ? data.url.substring(0,11):'') == "/binmanager") {
          this.binesParams = data;
          this.datosBean.binesList = data.binManagerAdqiEmisor.binesList;
          this.datosBean.idTipoBin = data.idTipoBin; 
          this.datosBean.idInstitucion = data.idInstitucion;
          this.binesParams.origenInfo = data.origenInfo;
          this.datosBean.origenInfo = data.origenInfo;
          if (null != this.datosBean && (4 == this.datosBean.idTipoBin || 8 == this.datosBean.idTipoBin)) {
            this.isCheck = true;
          }

          
          this.binesParams.idInstitucion = data.idInstitucion;
          this.idInstitucionAnterior = data.idInstitucion;
          if(undefined != data.idTipoBin && null != data.idTipoBin) {
            this.binesParams.binManagerAdqiEmisor.idTipoBin = data.idTipoBin;
          }
          this.regresar = data.url;
          if(null != data && data.tipoAccion == 3) {
            this.buscarCamposPlantilla(true);
          } else {
            this.buscarCamposPlantilla(false);
          }
          this.plantillaConsulta = false;          
        } else {
          this.datosBean.idTipoBin = 0;          
          this.idInstitucionAnterior = data ? data.idInstitucion : -1;
          // if(undefined != data && null != data) {
          //   this.datosBean.idTipoBin = data.idTipoBin;
          // } 
          this.datosBean.idInstitucion =-1;
          this.datosBean.enviado = false;          
          this.datosBean.origenInfo = data != undefined ? data.origenInfo : this.origenInfo;
          this.datosBean.idGrupo = data != undefined ? data.idGrupo : this.idGrupo;
          }
      },err=>{},
      ()=> {},
      );

    this.camposConfigModel = new Array<CamposConfigModel>();
    this.isOnChange = false;
    this.options = global.optionsByPickerdate;
    this.idBin = this._router.snapshot.paramMap.get('idBin');
    this.grupo = this._router.snapshot.paramMap.get('grupo');
   
    this.camposformulario = new Array<FormularioDinamicoModel>();
    this.tipoBines = new Array<CatalogoModel>();
    this.binRequest = new BinGenericRequest();
  
    this.camposPlantilla = [];
    this.instituciones = [];
    this.numeroSecciones = 1;
    this.seccionActual = 0;
    this.datePipe = new DatePipe('es-Mx');
    
  }

  ngOnInit() {
    this.emisorNacionalRequest.bubBinesBubCatTipoBinIdTipoBinPk = 2;
    this.buscarTipoBin();
    this.buscarInstituciones();
    this.instituciones=[];
    this.tipoBines = [];
    this.deshabilitar = false;
    
    if ( this.idBin && this.plantillaConsulta){
      this.buscarCamposPlantilla(true);
    } else {
      this.obsCampos.obs.next(EMPTY);

    }
    this.isOnChange = false;
  }

  ngAfterViewInit() {
    $('.collapsible').click(function(){
      $(this).collapsible({onOpen:function(el){ 
      $( ".select-dropdown" ).css("margin-bottom","0");
      $(".columna").css("margin-bottom","20");
      }});
    });
  }

  buscarTipoBin() {
    let scope = this;

    if(undefined != scope.binesParams &&  null != scope.binesParams.bin) {      
      scope.datosBean.bin = scope.binesParams.bin;
    }
    this.zeroService.request({
      uri: REST_SERVICES.CATALOGO_TIPO_BIN,
      method: 'GET',
      showInfo: true,
      isSingleResponse: false,
      ok:  response => {
        if (response.responsecode == "0") {
          response.response.forEach(element => {
            if (scope.isCheck) {
              scope.tipoBines = response.response;
            } else {
              if (element.id != 4 && element.id != 5 && element.id != 7 && element.id != 8 && element.id != 9 && element.id != 10) {
                scope.tipoBines.push(element);
              }
            }
          });
          // scope.tipoBines = response.response;
        }
      }
    });
  }
 
   cambioTipoBin() {
     this.datosBean.idInstitucion = -1;
     this.camposPlantilla = [];
     this.buscarInstituciones();
   }
 
   buscarInstituciones() {
    this.bin.nativeElement.value = "";
  let urlI = REST_SERVICES.CATALOGO_INSTITUCIONES_ID.replace("%id",this.datosBean.idTipoBin != undefined?this.datosBean.idTipoBin:this.tipoBin.nativeElement.value);
  if(this.datosBean.idInstitucion != undefined){
    urlI = urlI.replace("%ins","&idInstitucion="+this.datosBean.idInstitucion);
    }else{
    urlI=urlI.replace("%ins","&idInstitucion=0"); 
  }      
    let scope = this;
    this.zeroService.request({
        uri: urlI,
        method: 'GET',
        showInfo: true,
        isSingleResponse: false,
        ok: function (response) {
          if (response.responsecode == "0") {
            scope.instituciones =[];
            scope.instituciones= response.response;
          }
        }
      });
  }
  
  validaEdicion(response:any) {
    this.instituciones = response;
    this.isOnChange = false;
    if(!this.idBin) {
      this.instituciones = response;
      this.isOnChange = false;
    }
  }
 
  validarCampos(){
    let scope = this; 
    this.formularioConError = false;
    this.camposPlantilla.forEach( x=> {
        x.seccionesResponse.forEach(seccion => {
          seccion.valid = true;
            seccion.camposConfig.forEach( campo => {
              if ( campo.idCampoPk == 15 ){
              }
                  if ( campo.tipoCampo == 4 ){
                    scope.validarCombo( campo );
                  }
                  else{
                    scope.validarInput(campo);
                  }
                  if( !campo.valid ){
                    scope.formularioConError = true;
                    seccion.valid = false;
                  } else {
                    campo.validBlanck = true;
                  }
                   
            })
        });
    });
    if ( this.camposPlantilla.length == 0 ){
      this.formularioConError = true;
    }
  }

  validarCampo(campo:any){
    let scope = this; 
    
    if ( campo.tipoCampo == 4 ){
      scope.validarCombo(campo);
    }
    else{
      scope.validarInput(campo);
    }
    if( !campo.valid ){
      scope.formularioConError = true;
    } else {
      campo.validBlanck = true;
    }               
    if ( this.camposPlantilla.length == 0 ){
      this.formularioConError = true;
    }
  }

  guardar() {
    let scope = this;
    this.validarCampos();
    this.datosBean.enviado = true;
    let seccion:number = 0;
    scope.acordeon.close(0);
    this.datosBean.binValid = this.datosBean.bin ? true : false; 
    scope.binRequest.procedencia = undefined != scope.binesParams ? this.binesParams.url.substring(0,11) : "";
    
    this.camposPlantilla.forEach(plantilla => {
      plantilla.seccionesResponse.forEach( element => {
        seccion++;
        scope.acordeon.close(seccion);
      });
    });
     if ( !this.formularioConError && this.datosBean.bin  ){
    //   this.toastService.show(
    //     '<h5>Mensaje de sistema...</h5> <span> Ingresar los datos requeridos </span>',
    //     scope.global.timeoutToast, 'red'); 
    let protocolo = 'POST';
    
    if ( scope.idBin ){
      protocolo = 'PUT';
    }
    this.llenarBinResquest();
    let binValido = this.validarRangoBin(this.binRequest.baseBine.bin);
    if (binValido) {
        this.zeroService.request({
          uri: REST_SERVICES.GUARDAR_CAMPOS_PLANTILLA,
          method: protocolo,
          showInfo: true,
          isSingleResponse: false,
          params: scope.binRequest,
          ok: function (response) {
          
            scope.obsCampos.obs.next(EMPTY);
            let navigationExtras: NavigationExtras = {
              queryParams: {
                'bin' : (undefined == scope.binesParams) ? "" : scope.binesParams.bin, refresh: new Date().getTime()
              }           
            };
            scope.router.navigate([(undefined != scope.binesParams && null != scope.binesParams.url) ?  scope.binesParams.url.substring(0,11) : "/busquedaEjecutor"], navigationExtras);
            if (response.responsecode == "0") {
              // scope.toastService.show(
              //   '<h5>Mensaje de sistema...</h5> <span>'+ response.responseMessage +'</span>',
                // scope.global.timeoutToast, 'blue', );
                
                scope.toastr.success('<h5>Mensaje de sistema...</h5> <span>'+ response.responseMessage +'</span>', "",
                { closeButton: false, enableHtml: true, disableTimeOut: false });
                

            }
          }
        });
      }
     }
    
  }

  llenarBinResquest(){
    this.binRequest.comentarioOpe='';
    this.binRequest.origenInfo = this.datosBean.origenInfo
    this.binRequest.rol=localStorage.getItem('currentRol');
    this.binRequest.baseBine.bubBinesBubCatTipoBinIdTipoBinPk = this.datosBean.idTipoBin;
    this.binRequest.baseBine.bubBinesBubCatInstitucionesIdInstitucionPk = this.datosBean.idInstitucion;    
    this.binRequest.binesList = this.datosBean.binesList;
    if ((this.binesParams != undefined && this.binesParams != null && this.binesParams.url.substring(0,11) == "/binmanager" && this.binesParams.binManagerAdqiEmisor.grupo != null)) {
      this.binRequest.baseBine.bin = this.binRequest.binesList;
    } else {
      this.binRequest.baseBine.bin = this.datosBean.bin.toString();
    }    

    if(this.binesParams != undefined && this.binesParams != null && this.binesParams.url.substring(0,11) == "/binmanager" && this.binesParams.binManagerAdqiEmisor.grupo == null){
      this.binRequest.binesList = null;
    }

    if (this.grupo == "G" && this.binesParams != undefined && this.binesParams != null && this.binesParams.url.substring(0,11) == "/binmanager") {
      this.binRequest.idGrupo = null;
    } else if (this.grupo == "G") {
      this.binRequest.idGrupo = parseInt((undefined != this.idBin) ? this.idBin : this.binesParams.idBin);
    }

    if (this.binesParams && this.binesParams.binManagerAdqiEmisor && this.binesParams.binManagerAdqiEmisor.fechaSolicitud) {
      this.binRequest.baseBine.fechaSolicitud = this.binesParams.binManagerAdqiEmisor.fechaSolicitud;
    }
    if ( !this.idBin ){
      this.binRequest.baseBine.usuarioAlta = this.authenticationService.currentUserValue.username;
      this.binRequest.baseBine.fchAlta = this.datePipe.transform(new Date(), 'yyyy-MM-dd');

    }
    else{
      this.binRequest.baseBine.idBinPk = parseInt((undefined != this.idBin) ? this.idBin : this.binesParams.idBin);
      this.binRequest.baseBine.usuarioMod = this.authenticationService.currentUserValue.username;
      this.binRequest.baseBine.fchMod = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      this.binRequest.baseBine.regTemp = this.isInter ? "1" : "0";
    }
    
    this.binRequest.baseBine.institucion = this.instituciones.find( x => x.id == this.datosBean.idInstitucion ).descripcion;
    if (this.idInstitucionAnterior == null || this.idInstitucionAnterior == undefined || this.idInstitucionAnterior == -1) {
      this.idInstitucionAnterior = this.datosBean.idInstitucion;
    }
    this.binRequest.baseBine.institucionAnterior = this.instituciones.find( x => x.id == this.idInstitucionAnterior ).descripcion;
    this.binRequest.camposExtra = [];
    this.camposPlantilla.forEach(plantilla => {
      plantilla.seccionesResponse.forEach(seccion => {
        seccion.camposConfig.forEach(campo => {
        let campoExtra = new CampoExtraRequest();
        campoExtra.valor = campo.valor != null ? encodeURIComponent(campo.valor) : campo.valor;
        if(campo.tipoCampo == 4) {
          let campoVal = campo.valor;
          let valores = campo.valoresSelResponse;
          valores.forEach(val => {
            if(campoVal == val.valor ){
              campoExtra.descValor = val.descripcion;
            }
          });
          
        } else {
          campoExtra.descValor = null;
        }
        campoExtra.bubCatCamposConfigIdCampoPk = campo.idCampoPk;
        campoExtra.idBinFk = this.binRequest.baseBine.idBinPk;
        campoExtra.bubBinesIdBinPk = this.binRequest.baseBine.idBinPk;
        campoExtra.descripcionCampo = campo.dsc.replace(' *', '');
        campoExtra.estatus = seccion.isSeccionInternacional ? 1 : 0;
        this.binRequest.camposExtra.push( campoExtra );
        });
      });
    });
  }

  cancela() {
    this.modal.openModal();
  }
  
  cancelarAceptar() {
    this.router.navigate([(undefined != this.binesParams) ? this.binesParams.url.substring(0,11) : '/busquedaEjecutor'], {
      queryParams: { refresh: new Date().getTime() }
    });
    this.obsCampos.obs.next(EMPTY);
  }

  validarInput( campo:CamposConfigModel){
             
    campo.touched = true;     
        
      if ( campo.requerido ==1 && !campo.valor && campo.tipoCampo != 3  ){ // valida campo vacio exepto check
        campo.valid = false;
        return;
      }

      if ( campo.requerido ==1 && !campo.valor && campo.tipoCampo == 3  ){ // valida campo check
        campo.valid = false;
        return;
      }

      campo.valid = true;       
  }
  validarCombo( campo:CamposConfigModel ){
     
    if ( campo.requerido == 1   ){
      campo.valid = (campo.valor == 0 || campo.valor == 'null' || campo.valor == null) ? false : true ;
      campo.touched =true;
       
    }
  }
  buscarCamposPlantilla( esConsulta:boolean ){
    let scope = this;
    let url = '';
    let metodo = '';

    let isBinManagerService: boolean = false;

    if (this.instSelected) {
      this.cambioInstitucion();
      this.validarEdicion();
    }

    if((scope.binesParams != undefined && scope.binesParams.idBin != undefined && scope.binesParams.idBin != "0" && !this.instSelected) || (this.idBin && !this.instSelected)) {

      if ( esConsulta || ( this.datosBean.idTipoBin != 0 && this.datosBean.idInstitucion !=-1 ) ){

        this.camposPlantilla = [];
        
        if(undefined != scope.binesParams) {
          if ( esConsulta && (scope.binesParams.url.substring(0,11) == "/binmanager")  ){
            url = REST_SERVICES.BUSQUEDA_BIN_BY_ID_POST.replace('%id', (undefined != this.idBin) ? this.idBin : this.binesParams.idBin );
            metodo = 'POST';
            isBinManagerService = true;
          } else if(esConsulta && (scope.binesParams.url.substring(0,11) != "/binmanager")) {
            url = REST_SERVICES.BUSQUEDA_BIN_BY_ID.replace('%id', (undefined != this.idBin) ? this.idBin : this.binesParams.idBin ).replace('%origen',this.origenInfo != null ? this.origenInfo : this.datosBean.origenInfo + '').replace('%grupo',this.grupo != null ? this.grupo : '');
            metodo = 'GET';
            isBinManagerService = false;
          } else {
            url = REST_SERVICES.BUSQUEDA_CAMPOS_PLANTILLA;
            metodo = 'POST';
            isBinManagerService = false;
          }
        } else {
          url = REST_SERVICES.BUSQUEDA_BIN_BY_ID.replace('%id', this.idBin ).replace('%origen',this.origenInfo != null ? this.origenInfo : this.datosBean.origenInfo + '').replace('%grupo',this.grupo != null ? this.grupo : '');
          metodo = 'GET';
        }
        let numSeccionesDinamicas = 0;
        this.zeroService.request({
          uri: url,
          method: metodo,
          showInfo: true,
          isSingleResponse: false,
          params: (undefined != scope.binesParams) ? this.binesParams.binManagerAdqiEmisor : null,
          ok: function (response) {
            let respuesta = response.response;
            if (response.responsecode == "0") {
        
               scope.camposPlantilla = respuesta;
               scope.camposPlantilla.forEach( x => {
                        x.seccionesResponse.forEach(seccion => {
                          numSeccionesDinamicas ++;
                          let isIntern = seccion.isSeccionInternacional;
                          if (!scope.isInter) {
                            scope.isInter = isIntern;
                          }
                          seccion.camposConfig.forEach( y => {
                            y.disabled = scope.isCheck;
                            if (isIntern && !scope.isCheck) {
                              y.disabled = false; 
                            }
                            if (!y.valor && scope.isCheck) {
                              y.valor=" ";
                            }
                            if ( !y.requerido  ){
                              y.valid = true; 
                            }
                            else{
                              y.dsc+= ' *';
                            }
                            if ( y.tipoCampo == 4 ){
                              y.valor =  (y.valor != null) ?  y.valor : "" ;
                              //y.valor =  esConsulta ?  y.valor : "" ;
                              if (scope.isCheck && !y.valor) {
                                y.valor  ="";
                              }

                              if (y.idCampoPk == 63) {
                                this.valNatBin = y.valor;
                              }
                            }
                            else if( y.tipoCampo == 3 ){
                              y.valor = (y.valor != null && y.valor.trim().length > 0) ? JSON.parse(y.valor) :false;
                              // if (y.idCampoPk === 72) {
                              //   y.disabled = true;
                              // }
                            }
                          }  );
                          seccion.numeroSeccion = numSeccionesDinamicas;
                        })
                        
               } );
               scope.camposPlantilla = respuesta;
               scope.numeroSecciones = numSeccionesDinamicas + 1;
               if ((numSeccionesDinamicas > 0 && esConsulta) || (scope.binesParams.url.substring(0,11) == "/binmanager")){
                  scope.datosBean.bin = scope.camposPlantilla[0].bin;
                  scope.datosBean.idTipoBin = scope.camposPlantilla[0].idTipoBin;
                  scope.datosBean.idInstitucion = scope.camposPlantilla[0].idInstitucion;
               // Se busca los datos de la institucion, naturaleza de bin para validar cash credito, card fi y prefijos del bin.
                if (scope.datosBean.idTipoBin != 4 && scope.datosBean.idTipoBin != 8) {
                  scope.obtieneDatosInstiEdicion(scope.datosBean.idInstitucion, this.valNatBin);
                }
               }
               // solo aplica para check de bin
               if (scope.isCheck) {
                  scope.validaCampoModificado(+scope.idBin, scope.camposPlantilla[0].bin);
               }  
            }
          }
        });
      }
    } else if (this.datosBean.idTipoBin != 0 && this.datosBean.idInstitucion !=-1 && !this.instSelected){
         
        this.camposPlantilla = [];

        if(undefined == this.binesParams) {
          var binesParams = new BinManagerParams();
          binesParams.idInstitucion = scope.datosBean.idInstitucion;
          binesParams.idTipoBin = scope.datosBean.idTipoBin;
        }

        let numSeccionesDinamicas = 0;
        this.zeroService.request({
          uri: REST_SERVICES.BUSQUEDA_CAMPOS_PLANTILLA,
          method: 'POST',
          showInfo: true,
          isSingleResponse: false,
          params: (undefined == this.binesParams) ? binesParams : this.binesParams.binManagerAdqiEmisor,
          ok: function (response) {
            let respuesta = response.response;

            if (response.responsecode == "0") {
               scope.camposPlantilla = respuesta;
               
               let count = 0;
               scope.camposPlantilla.forEach( x => {
                        x.seccionesResponse.forEach(seccion => {
                          numSeccionesDinamicas ++;
                          seccion.camposConfig.forEach( y => {
                            scope.camposConfigModel.filter(y => y.dsc == "");
                        
                            y.disabled = scope.isCheck ;
                            if (!y.valor && scope.isCheck) {
                              y.valor=" ";
                            }
                            if ( !y.requerido  ){
                              y.valid = true; 
                            }
                            else{
                              y.dsc+= ' *';
                            }
                            if ( y.tipoCampo == 4 ){
                              y.valor =  y.valor != null ?  y.valor : "" ;
                              if (scope.isCheck && !y.valor) {
                                y.valor  ="";
                              }
                            }
                            else if( y.tipoCampo == 3 ){
                              y.valor = (y.valor != null && y.valor.trim().length > 0) ? JSON.parse(y.valor) :false;
                            }
                            count++;
                          }  );
                          seccion.numeroSeccion = numSeccionesDinamicas;
                        })
                        
               } );
               scope.numeroSecciones = numSeccionesDinamicas + 1;
               if ( numSeccionesDinamicas > 0){
                  scope.datosBean.bin = scope.camposPlantilla[0].bin;
                  scope.datosBean.idTipoBin = scope.camposPlantilla[0].idTipoBin;
                  scope.datosBean.idInstitucion = scope.camposPlantilla[0].idInstitucion;
                  // función que obtiene la institución con la bandera de cashCredito.
                 scope.obtieneIdInstitucionCash(scope.datosBean.idInstitucion);
                 scope.validaFlgCashCreditoBinManager(isBinManagerService);
      
               }
               
            }
          }
        });      
    }
    if ((this.idBin&&!this.isCheck) || (undefined != scope.binesParams && scope.binesParams.url.substring(0,11) == "/binmanager")) {
      this.instSelected = true;
      this.isBinManager = true;
    }    
    
  }

  
  validarNumber(campo:CamposConfigModel, e:KeyboardEvent ){
    if ( e.keyCode == 69 ||  e.keyCode == 101   ){
      return false;
    }
    
    if ( campo.valor && campo.longitud &&  campo.valor.toString().length > campo.longitud ){
      campo.valor= campo.valor.toString().substring(0, campo.longitud );
    }

  }
  
   validarRangoBin(valorBin: string): Boolean {
    //Solo se permite el alta por rango o serie, en BINES Emisor Nacional
    var msn:string ="";
    var prefijos = this.prefijosBin != undefined ? this.prefijosBin.split(",") : null;
    if (this.datosBean.idTipoBin != 1 && (valorBin.includes(",") || valorBin.includes("-"))) {
      msn = '<h5>Mensaje de sistema...</h5> <span>El tipo de BIN seleccionado no permite alta por rangos, ni serie</span>';
      this.toastr.warning(msn, "", {
        closeButton: false,
        enableHtml: true,
        disableTimeOut: false
      });
      return false;
    } 
	  if (valorBin.includes("-") && !valorBin.includes(",")) {
      var binesIn = valorBin.split('-');
      binesIn = binesIn.filter(function (e) { return e.replace(/(\r\n|\n|\r)/gm,""); });
      if(binesIn.length != 2) {
        msn = '<h5>Mensaje de sistema...</h5> <span>Rango invalido, el rango de bines debe estar formado por un BIN inicial y un BIN final. </span>';
        this.toastr.warning(msn, "", {
          closeButton: false,
          enableHtml: true,
          disableTimeOut: false
        });
        this.bin.nativeElement.focus();
        return false;
      }

      if(binesIn[0] > binesIn[1]) {
        msn = '<h5>Mensaje de sistema...</h5> <span>Rango invalido, el BIN inicial debe ser menor al BIN final. </span>';
        this.toastr.warning(msn, "", {
          closeButton: false,
          enableHtml: true,
          disableTimeOut: false
        });
        this.bin.nativeElement.focus();
        return false;
      }

      const prefijosIniciales = binesIn[0].trim().slice(0, 6);
      let tamValido = binesIn.every(bin => bin.trim().length == 8);
      let sonValidos = binesIn.every(bin => bin.trim().startsWith(prefijosIniciales));
      if (!sonValidos) {
        msn = '<h5>Mensaje de sistema...</h5> <span>Los primeros 6 dígitos deben ser iguales en todos los BIN ingresados. </span>';
        this.toastr.warning(msn, "", {
          closeButton: false,
          enableHtml: true,
          disableTimeOut: false
        });
        this.bin.nativeElement.focus();
        return false;
      }

      if (!tamValido) {
        let msn = '<h5>Mensaje de sistema...</h5> <span>Longitud invalida, la longitud de todos los bines debe ser de 8. </span>';
        this.toastr.warning(msn, "", {
          closeButton: false,
          enableHtml: true,
          disableTimeOut: false
        });
        this.bin.nativeElement.focus();
        return false;
      }

	    if (binesIn.length > 0) {
        binesIn.forEach((initVal) => {
          if (prefijos != null && !prefijos.includes(initVal.charAt(0))) {
            msn = '<h5>Mensaje de sistema...</h5> <span>Prefijo del BIN invalido, el BIN solo puede iniciar con ' + this.prefijosBin + '</span>';
            this.toastr.warning(msn, "", {
              closeButton: false,
              enableHtml: true,
              disableTimeOut: false
            });
            this.bin.nativeElement.focus();
            return false;
          }
        });
      }
    } else if (valorBin.includes(",") && !valorBin.includes("-")) {
      const bines = valorBin.split(',');
      const prefijosIniciales = bines[0].trim().slice(0, 6);
      let sonValidos = bines.every(bin => bin.trim().startsWith(prefijosIniciales));
      let tamValido = bines.every(bin => bin.trim().length == 8);
      let hasValoresRepetidos = bines.some((e, i, arr) => arr.indexOf(e) !== i);
      const toFindDuplicates = bines => bines.filter((item, index) => bines.indexOf(item) !== index)
      const duplicateElementa = toFindDuplicates(bines);
      if (!sonValidos) {
        let msn = '<h5>Mensaje de sistema...</h5> <span>Los primeros 6 dígitos deben ser iguales en todos los BIN ingresados, prefijo invalido. </span>';
        this.toastr.warning(msn, "", {
          closeButton: false,
          enableHtml: true,
          disableTimeOut: false
        });
        this.bin.nativeElement.focus();
        return false;
      }

      if (!tamValido) {
        let msn = '<h5>Mensaje de sistema...</h5> <span>Longitud invalida, la longitud de todos los bines debe ser de 8. </span>';
        this.toastr.warning(msn, "", {
          closeButton: false,
          enableHtml: true,
          disableTimeOut: false
        });
        this.bin.nativeElement.focus();
        return false;
      }

      if (hasValoresRepetidos) {
        let msn = '<h5>Mensaje de sistema...</h5> <span>No se permiten bines duplicados en la lista' + duplicateElementa + '. </span>';
        this.toastr.warning(msn, "", {
          closeButton: false,
          enableHtml: true,
          disableTimeOut: false
        });
        this.bin.nativeElement.focus();
        return false;
      }

	    if (bines.length > 0) {
        bines.forEach((initVal) => {
          if (prefijos != null && !prefijos.includes(initVal.charAt(0))) {
            msn = '<h5>Mensaje de sistema...</h5> <span>Prefijo del BIN invalido, el BIN solo puede iniciar con ' + this.prefijosBin + '</span>';
            this.toastr.warning(msn, "", {
              closeButton: false,
              enableHtml: true,
              disableTimeOut: false
            });
            this.bin.nativeElement.focus();
            return false;
          }
        });
      }
    }
    else if(valorBin.length <= 8){
      if (prefijos != null && !prefijos.includes(valorBin.charAt(0))) {
        msn = '<h5>Mensaje de sistema...</h5> <span>Prefijo del BIN invalido, el BIN solo puede iniciar con ' + this.prefijosBin + '</span>';
        this.toastr.warning(msn, "", {
          closeButton: false,
          enableHtml: true,
          disableTimeOut: false
        });
        this.bin.nativeElement.focus();
        return false;
      }
    }


    //Alta de BINES indicando Bin inicial y Bin final
    let bines = valorBin.trim().split("-");
    if (valorBin.includes("-") && !valorBin.includes(",") && bines.length == 2) {
      this.binRequest.baseBine.binInicio = bines[0];
      this.binRequest.baseBine.binFinal = bines[1];
      let binInicio = bines[0].length == 8 ? bines[0].substring(0, 6) : bines[0];
      let binFinal = bines[1].length == 8 ? bines[1].substring(0, 6) : bines[1];
      if ((binInicio != binFinal) && bines[0].length == 8 && bines[1].length == 8) {
        var mensaje = '<h5>Mensaje de sistema...</h5> <span>Prefijo del BIN invalido, los prefijos deben coincidir.</span>';
        this.toastr.warning(mensaje, "",
          { closeButton: false, enableHtml: true, disableTimeOut: false });
        return false;
      }

      if (bines[0].length != 8 || bines[1].length != 8) {
        var mensaje = '<h5>Mensaje de sistema...</h5> <span>Rango del BIN invalido, la longitud del bin inicial y final debe ser de 8 d&iacute;gitos.</span>';
        this.toastr.warning(mensaje, "",
          { closeButton: false, enableHtml: true, disableTimeOut: false });
        return false;
      }


    } else if (valorBin.includes(",") && !valorBin.includes("-")) {
      //Alta de BINES separados por coma
      this.binRequest.binesList = valorBin
    } else if (!valorBin.includes(",") && !valorBin.includes("-") && (this.grupo && this.grupo != "G")) {
      if(valorBin.length != 8 && this.datosBean.idTipoBin == 1) {
        let msn = '<h5>Mensaje de sistema...</h5> <span>Longitud invalida, la longitud del bin debe ser de 8. </span>';
        this.toastr.warning(msn, "", {
          closeButton: false,
          enableHtml: true,
          disableTimeOut: false
        });
        this.bin.nativeElement.focus();
        return false;
      }
    }
    return true;
  }


  alertaPrefijos(valor: string) {
     this.validarRangoBin(valor);
  }

  validarNumberBin(e: KeyboardEvent, valor: string) {
    //Alerta solo se permite el alta por rango o serie, en BINES Emisor Nacional
    if (this.datosBean.idTipoBin != 1 && (valor.includes(",") || valor.includes("-"))) {
      mensaje = '<h5>Mensaje de sistema...</h5> <span>El tipo de BIN seleccionado no permite alta por rangos, ni serie</span>';
      this.toastr.warning(mensaje, "", {
        closeButton: false,
        enableHtml: true,
        disableTimeOut: false
      });
      return false;
    }
    var prefijos = this.prefijosBin != undefined ? this.prefijosBin.split(",") : null;
    var mensaje = "";
    let partesValor = [];
    if ((valor != null || valor != undefined) && (e.keyCode >= 48 && e.keyCode <= 57)) {
      if (valor.includes(",")) {
        partesValor = valor.split(',');
      } else if (valor.includes("-")) {
        partesValor = valor.split('-');
      } else{
        partesValor[0] = valor;
      }
    }else {
      partesValor[0] = valor;
    }
    if (partesValor.length > 0) {
      partesValor.forEach((initVal) => {
        if (prefijos != null && !prefijos.includes(initVal.charAt(0)) && ((e.keyCode >= 48 && e.keyCode <= 57) || e.keyCode == 44 || e.keyCode == 45 || e.keyCode == 188 || e.keyCode == 189)) {
          mensaje = '<h5>Mensaje de sistema...</h5> <span>Prefijo del BIN invalido, el BIN solo puede iniciar con ' + this.prefijosBin + '</span>';
          this.toastr.warning(mensaje, "", {
            closeButton: false,
            enableHtml: true,
            disableTimeOut: false
          });
          return false;
        }
      });
    } 
  }
  
  siguienteSeccion(seccionactual:number){
    if( this.numeroSecciones-1 > seccionactual ){
      for ( var i = 0;i< this.numeroSecciones-1;  i++ ){
        this.acordeon.close(i);
      }       
      this.acordeon.open(seccionactual+1);
    }
  }
  seccionAterior(seccionactual:number){
    if(  seccionactual > 0 ){
      for ( var i = 0;i< this.numeroSecciones-1;  i++ ){
        this.acordeon.close(i);
      }
      this.acordeon.open(seccionactual-1);
    }
  }
  setear(){
    
    let seccion = 0;  
    this.camposPlantilla.forEach(plantilla => {
           plantilla.seccionesResponse.forEach(element => {
             seccion++
           });
      });
  }

  expandirCollapsables() {
    if (this.numeroSecciones > 1) {
      for (var i = 0; i < this.numeroSecciones; i++) {
        this.acordeon.open(i);
      }
    }
  }

  validarEdicion() {  
    this.isOnChange = true;
  }

  // Obtiene los campos modificados almacenados en la tabla de bitacora de movimientos
  // y valida para marcarlos en color verde.
  validaCampoModificado(idBinParam: number, binParam: string) {
    let scope = this;
    scope.datoBinModificado.idBin = idBinParam;
    scope.datoBinModificado.bin = binParam;    
    scope.datoBinModificado.origenInfo = (this.origenInfo != undefined && this.origenInfo != null) ? Number(this.origenInfo) : 2;
    if ( this.grupo != undefined && this.grupo != null && this.grupo == "G") {
      //Indica que la busqueda es por grupo
      scope.datoBinModificado.tipo = "G";
      scope.datoBinModificado.grupo = idBinParam.toString();
    } else {
      //Indica que la busqueda es por grupo
      scope.datoBinModificado.tipo = "I";
    }
    scope.zeroService.request({
      uri: REST_SERVICES.BUSQUEDA_CAMPOS_MODIFICADOS_BIN,
      method: 'POST',
      showInfo: true,
      isSingleResponse: false,
      params: scope.datoBinModificado,
      ok: (response) => {
          scope.campos = response.response;
          if (scope.campos.length > 0) {
            scope.campos.forEach(campoModifado => {
              scope.camposPlantilla.forEach(plantilla => {
                plantilla.seccionesResponse.forEach (seccion  => {
                  seccion.camposConfig.forEach( campo => {
                    let campoId = campo.idCampoPk;
                    if (campoModifado === campoId+'') {
                      campo.modificado = true;
                    } 
                  })
                });
              })
            });
          }
      }
    });
  }

  // cambia el color del texto
  cambiaColor(modificado: boolean){
    return modificado ? "modificado":"";
  }
  
  
  /**
   * Función que obtiene la información de la institución para realizar la validación de cash credito 
   * y desactivas/activar el campo CASH BACK
   * @param idInstitucion    Id insitución a buscar obtenido de la consulta del bin.
   * @param valorNatBin      Valor de la naturaleza de bin obtenido de la consulta del bin.
   */
  obtieneDatosInstiEdicion(idInstitucion: number, valorNatBin: number) {   
    let urlI = REST_SERVICES.CATALOGO_INSTITUCIONES_ID.replace("%id",this.datosBean.idTipoBin != undefined?this.datosBean.idTipoBin:this.tipoBin.nativeElement.value);
    if(this.datosBean.idInstitucion != undefined){
      urlI = urlI.replace("%ins","&idInstitucion="+this.datosBean.idInstitucion);
      }else{
      urlI=urlI.replace("%ins","&idInstitucion=0"); 
    }
    let scope = this;
    scope.zeroService.request({
        uri: urlI,
        method: 'GET',
        showInfo: true,
        isSingleResponse: false,
        ok: (response) => {
          if (response.responsecode == "0") {
            scope.instituciones =[];
            scope.instituciones= response.response;
            // busca la insittucion para obtener los datos de cashCredito.
            scope.obtieneIdInstitucionCash(idInstitucion);
            // valida si el producto es Credito y la bandera  de cashCredito es verdadera
            if (valorNatBin + '' === 1 + '' && scope.datosInstitucionCash.cashCredito === false) {
              scope.camposPlantilla[0].seccionesResponse.forEach (seccion  => {
                seccion.camposConfig.forEach( campo => {
                  if ( campo.tipoCampo == 3 ){   // para los campos que son check
                    if ( campo.idCampoPk == 72) { // busca el check de CASH BACK
                      if (scope.datosInstitucionCash.cashCredito === false) {
                        campo.disabled = true;
                        campo.valor = false;
                      } else  {
                        campo.disabled = false;
                      }
                    } 
                  }
                })
              });
            }
          }
        }
      });
  }
  /**
   * Función que obtiene los datos de la institucion seleccionada del combo y el valor de cashCBackBloqueado en false.
   * 
   * Asigna los valores de la institución al objeto que va a servir para validar el cashBackk.
   */
  private obtieneIdInstitucionCash(idInstitucion: number) {
    var idInstCash: number = +idInstitucion
    this.instituciones.forEach(ele =>{
      if (idInstCash === ele.id) { 
        console.log("insitución: ", ele);
        this.datosInstitucionCash.id = ele.id;
        this.datosInstitucionCash.clave = ele.clave;
        this.datosInstitucionCash.soporteCash = ele.soporteCash;
        this.datosInstitucionCash.cashCredito = ele.cashCredito;
        this.datosInstitucionCash.cashBackBloqueado = false;
        this.datosInstitucionCash.cardFiCredito = ele.cardFiCredito;
        this.datosInstitucionCash.cardFiDebito = ele.cardFiDebito;
        this.datosInstitucionCash.prefijoBin = ele.prefijoBin;
        this.prefijosBin = ele.prefijoBin;
      }
    });
  }

  /**
   * Función que obtiene el id de la naturaleza de bin cuando es alta por bin manager.
   * @param isBinManagerService  Bandera Indica si el request es por bin manager.
   */
  validaFlgCashCreditoBinManager(isBinManagerService: boolean) {
    let natBin: number;

    this.camposPlantilla[0].seccionesResponse.forEach (seccion  => {
      seccion.camposConfig.forEach( campo => {
        if ( campo.tipoCampo == 4 ){   // para los campos que son combo
          if ( campo.idCampoPk == 63) { // busca el check de CASH BACK
            natBin = +campo.valor;
          } 
        }
      })
    });

    //console.log("validaFlgCashCreditoBinManager-  natBin: ", natBin);
    //amcr: check if this is greatere than 0; update the value of the field card fi.
    if(natBin > 0){
      //console.log("asignando valor cardfi ");
        this.camposPlantilla[0].seccionesResponse.forEach(seccion => {
          seccion.camposConfig.filter(campo => campo.tipoCampo === 1 && campo.idCampoPk === 93)
          .forEach(campo => {
            this.asignarValorCardFi(campo, natBin); 
          });
        });
    }
    
    this.validaCashCredito(natBin);    
  }
  /**
   * Función que valida la bandera cashCredito cuando selecciona la opción CREDITO de la naturaleza del bin.
   * Cambia el valor de la bandera cashBackBloqueado a true para posterior uso.
   * Envia alerta indicando que el cashBack se bloqueo.
   */
  validaFlgCashCredito() {
    this.validarEdicion();

    let idNatBin: number = +this.valCashCredito.nativeElement.value;
    this.validaCashCredito(idNatBin);
  }

  /**
   * Función que realiza la validación de tipo de bin, la bandera de flagCashCredito para enviar alerta y validas cashbackS
   * @param idNatBin 
   */
  validaCashCredito(idNatBin: number) {

    let flgCashCredito: boolean = this.datosInstitucionCash.cashCredito;
    // valida el tipo de bin
    if (this.datosBean.idTipoBin === 1 || this.datosBean.idTipoBin === 2) {
        
       // valida si el producto es Credito y la bandera  de cashCredito es verdadera
       if (idNatBin === 1 && flgCashCredito === false) {
          this.datosInstitucionCash.cashBackBloqueado = true;
          this.toastr.warning('<h5>Mensaje de sistema...</h5> <span>Para el tipo de bin Emisor y la naturaleza Crédito, se deshabilita la opción CASH BACK</span>', "",
           { closeButton: false, enableHtml: true, disableTimeOut: false });
        } else {
           this.datosInstitucionCash.cashBackBloqueado = false;
        }
        // valida bandera para activar o desactivar CASHBACK
        this.validaCashBack(this.datosInstitucionCash.cashBackBloqueado);
    }

  }

  /**
   * Función que valida la banderacashBackBloqueado para activar o desactivar la opción CASHBACK.
   * @param flgCashBaclBloqueado   Valor booleano que indica si se activa o desactiva la opción CASHBACK.
   */
  private validaCashBack(flgCashBaclBloqueado: boolean) {
    this.camposPlantilla[0].seccionesResponse.forEach (seccion  => {
      seccion.camposConfig.forEach( campo => {
        if ( campo.tipoCampo == 3 ){

          if ( campo.idCampoPk == 72) {
            if (flgCashBaclBloqueado === true) {
              campo.disabled = true;
              campo.valor = false;
            } else  {
              campo.disabled = false;
            }            
          } 
        } else if ( campo.tipoCampo == 1 && this.valCashCredito != undefined){
          let idNatBin: number = +this.valCashCredito.nativeElement.value;
          //Valida si el campo es CARD FI y la NATURALEZA DEL BIN es crédito para setear el valor del CARD FI configurado para la institución
          //Valida si el campo es CARD FI y la NATURALEZA DEL BIN es débito o prepago para setear el valor del CARD FI configurado para la institución
          this.asignarValorCardFi(campo, idNatBin);
        }
      })
    });
  }

  // amcr: Función para obtener el valor de CARD FI según la naturaleza del BIN
  private obtenerValorCardFi(naturalezaBin: number): string {
    return naturalezaBin === 1 
      ? this.datosInstitucionCash.cardFiCredito || "" 
      : this.datosInstitucionCash.cardFiDebito || "";
  }

  //  amcr: Función para asignar valor a campo CARD FI con idCampoPk 93
  private asignarValorCardFi(campo: any, naturalezaBin: number): void {
    if (campo.idCampoPk === 93) {
      campo.valor = this.obtenerValorCardFi(naturalezaBin);
    }
  }

  /**
   * Función que limpia el valor de los atributos CASH BACK y NATURALEZA DEL BIN
   */
  private cambioInstitucion() {
    // Cuando el valor de la institución es modificada en la sección ACCIÓN ABC DE BINES, se aplican las siguientes validaciones
    // Se obtienen los atributos de la nueva institución seleccionada
    this.obtieneIdInstitucionCash(this.datosBean.idInstitucion);
    // Se obtiene el valor de la NATURALEZA DEL BIN
    let idNatBin: number = +this.valCashCredito != null && this.valCashCredito != undefined && this.valCashCredito.nativeElement != undefined ? this.valCashCredito.nativeElement.value:0;
    // Se valida si la bandera CASH CREDITO del atributo de la nueva institución esta activado
    if (this.datosInstitucionCash.cashCredito === false) {
      // Se reccorren todas las secciones de la plantilla de la institución
      this.camposPlantilla[0].seccionesResponse.forEach (seccion  => {
        // Se recorren todos los campos de cada sección para buscar los atributos a validar
        seccion.camposConfig.forEach( campo => {
          // Validación para campos de tipo CHECK
          if ( campo.tipoCampo == 3 ){
  
            // Valida si la NATURALEZA DEL BIN es CRÉDITO para limpiar el valor del atributo CASH BACK
            if ( campo.idCampoPk == 72) {
              if (idNatBin === 1) {
                if (campo.disabled === false) {
                  this.toastr.warning('<h5>Mensaje de sistema...</h5> <span>Para el tipo de bin Emisor y la naturaleza Crédito, se deshabilita la opción CASH BACK</span>', "",
                    { closeButton: false, enableHtml: true, disableTimeOut: false });
                }
                campo.disabled = true;
              } else {
                campo.disabled = false;
                campo.valor = false;
              }
            }
          }
          if (campo.tipoCampo == 1 ) {
            //Valida si el campo es CARD FI y la NATURALEZA DEL BIN es crédito para setear el valor del CARD FI configurado para la institución
            if (campo.idCampoPk == 93 && idNatBin === 1) {
              campo.valor = this.datosInstitucionCash.cardFiCredito!= undefined ? this.datosInstitucionCash.cardFiCredito : "";
              //Valida si el campo es CARD FI y la NATURALEZA DEL BIN es débito o prepago para setear el valor del CARD FI configurado para la institución
            } else if (campo.idCampoPk == 93 ) {
              campo.valor = this.datosInstitucionCash.cardFiDebito != undefined ? this.datosInstitucionCash.cardFiDebito : "";
            }
          }
        })
      });
    } else {
      // Valida si el atributo CASH BACK esta deshabilitado y lo habilita en caso de que la condicion se cumpla
      // Se reccorren todas las secciones de la plantilla de la institución
      this.camposPlantilla[0].seccionesResponse.forEach (seccion  => {
        // Se recorren todos los campos de cada sección para buscar el atributo a validar
        seccion.camposConfig.forEach( campo => {
          // Validación para campos de tipo CHECK
          if ( campo.tipoCampo == 3 ){  
            // Se valida si el campo es CASH BACK y si esta deshabilitado
            if ( campo.idCampoPk == 72 && campo.disabled) {
                campo.disabled = false;
            } 
          }
          if (campo.tipoCampo == 1 ) {
            //Valida si el campo es CARD FI y la NATURALEZA DEL BIN es crédito para setear el valor del CARD FI configurado para la institución
            if (campo.idCampoPk == 93 && idNatBin === 1) {
              campo.valor = this.datosInstitucionCash.cardFiCredito!= undefined ? this.datosInstitucionCash.cardFiCredito : "";
              //Valida si el campo es CARD FI y la NATURALEZA DEL BIN es débito o prepago para setear el valor del CARD FI configurado para la institución
            } else if (campo.idCampoPk == 93 ) {
              campo.valor = this.datosInstitucionCash.cardFiDebito != undefined ? this.datosInstitucionCash.cardFiDebito : "";
            }
          }
        })
      });
    }    
  }

  validaTipoBin(): boolean {
    return this.datosBean && (this.datosBean.idTipoBin == 1 || this.datosBean.idTipoBin == 3);
  }

  tieneCampoLongitud(): boolean {
    if (!this.camposPlantilla) {
      return false;
    }
    return this.camposPlantilla.some(plantilla =>
      plantilla.seccionesResponse.some(seccion =>
        seccion.camposConfig.some(campo => campo.tipoCampo == 1 && campo.idCampoPk == 333)
      )
    );
  }

}
